import gql from "graphql-tag";

/**
 * Generates membership badge pdf by ticketUuid
 * we have 2 types of badges: Regular one, and a special one for Locarno only.
 * we supply the var locarno = true if we want to generate the Locarno badge.
 * variable example:
 * {ticketUuid: 12026, locarno: false}
 */
export const GET_GenerateBadgePdfByUuid = gql`
  query GET_GenerateBadgePdfByUuid($ticketUuid: String!, $locarno: Boolean!) {
    generateMembershipBadgePdf(ticketUuid: $ticketUuid, locarno: $locarno) {
      pdfBase64
    }
  }
`;

/**
 * Generates membership badge pdf by ticketid
 * we have 2 types of badges: Regular one, and a special one for Locarno only.
 * we supply the var locarno = true if we want to generate the Locarno badge.
 * variable example:
 * {ticketId: 12026, locarno: false}
 */
export const GET_GenerateBadgePdfById = gql`
  query GET_GenerateBadgePdfById($ticketId: String!, $locarno: Boolean!) {
    generateMembershipBadgePdf(ticketId: $ticketId, locarno: $locarno) {
      pdfBase64
    }
  }
`;

export const GET_GenerateGiftcardPdfByUuid = gql`
  query GET_GenerateGiftcardPdfByUuid($ticketUuid: String!) {
    generateGiftcardPdf(ticketUuid: $ticketUuid) {
      pdfBase64
    }
  }
`;

export const GET_GenerateGiftcardPdfById = gql`
  query GET_GenerateGiftcardPdfById($ticketId: String!) {
    generateGiftcardPdf(ticketId: $ticketId) {
      pdfBase64
    }
  }
`;

export const Mutation_SignReceipt = gql`
  mutation SignFiskalyReceipt(
    $groupId: String!
    $deviceUid: String!
    $receiptUuid: String!
    $receiptDate: DateTime!
    $currency: String!
    $fullAmountInclVat: String!
    $paymentTypes: String!
    $vatAmounts: String!
    $lines: String!
  ) {
    signFiskalyReceipt(
      groupId: $groupId
      deviceUid: $deviceUid
      receiptUuid: $receiptUuid
      receiptDate: $receiptDate
      currency: $currency
      fullAmountInclVat: $fullAmountInclVat
      paymentTypes: $paymentTypes
      vatAmounts: $vatAmounts
      lines: $lines
    ) {
      qrCodeData
      signed
      timeSignature
      receiptNumber
    }
  }
`;

export const Mutation_StartOrder = gql`
  mutation StartOrder($deviceUid: String!, $orderSession: JSONObject!) {
    startOrder(deviceUid: $deviceUid, orderSession: $orderSession) {
      orderId
    }
  }
`;

export const Mutation_CompleteOrder = gql`
  mutation CompleteOrder(
    $deviceUid: String!
    $orderType: OrderType!
    $orderSession: JSONObject!
  ) {
    completeOrder(
      deviceUid: $deviceUid
      orderType: $orderType
      orderSession: $orderSession
    ) {
      govId
      url
      signature
    }
  }
`;

export const GET_OrderSessionById = gql`
  query GetOrderSessions($orderSessionId: String!) {
    getOrderSessions(orderSessionId: $orderSessionId) {
      total
      page
      pageSize
      totalPages
      items {
        id
        reference
        orderId
        state
        completionDate
        visitDate
        voucher
        discount
        sales
        vatExcluded
        vatIncluded
        fees
        payment
        balance
        groupId
        channel
        sessionStart
        sessionEnd
        syncedAt
        expireAt
        counterId
        seqNumber
        currency
        discounts
        toPay
        discountConfigs
        createdAt
        updatedAt
        orderLines {
          id
          lineId
          orderSessionId
          categoryId
          priceId
          timeSlotId
          priceName
          retailOptionId
          retailName
          categoryName
          quantity
          unitPrice
          overridePrice
          totalPrice
          totalPriceWithDiscount
          vatId
          addonType
          vatCode
          vatValue
          vatRate
          vatType
          mainLineId
          lineType
          createdAt
          updatedAt
          mainLineOrderSessionId
        }
        payments {
          id
          orderSessionId
          paymentMethod
          value
          metadata
        }
        vouchers {
          id
          orderSessionId
          code
          voucherId
          value
          mainVoucherId
          mainVoucherOrderSessionId
        }
      }
    }
  }
`;

export const Mutation_SignAustriaReceipt = gql`
  mutation signAustriaReceipt($deviceUid: String!, $orderSession: JSONObject!) {
    signAustriaReceipt(deviceUid: $deviceUid, orderSession: $orderSession) {
      qrCodeData
      cashRegisterSerialNumber
      signed
      timeSignature
      receiptNumber
    }
  }
`;
